import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'

export const validateNameIsValid = async (name: string, recordName: string | undefined = undefined) => {
  if (recordName !== name) {
    if (name) {
      const isNameUsed = await businessRuleServices.getByAll(`name__like=${name}`)
      if (!isNameUsed || isNameUsed?.length > 0) {
        return {
          message: 'ra.message.already_used',
          args: { name: 'El nombre' },
        }
      }
    }
  }

  return undefined
}

export const validatePriority = async (
  priority: number,
  currentWorkUnitToken: string,
  selectedProduct: any,
  recordPriority: number | undefined = undefined
) => {
  if (recordPriority !== priority) {
    if (
      currentWorkUnitToken &&
      selectedProduct?.token &&
      selectedProduct?.token?.length > 0 &&
      currentWorkUnitToken.length > 0
    ) {
      let params = `priority=${
        priority ? priority : 0
      }&work_unit_token=${currentWorkUnitToken}&product_token=${selectedProduct.token}`
      const isPropertyUsed = await businessRuleServices.getByAll(params)
      if (!isPropertyUsed || isPropertyUsed?.length > 0) {
        return {
          message: 'ra.message.already_used',
          args: { name: 'Esta prioridad' },
        }
      }
    }
  }

  return undefined
}
